import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { ApiMethod } from '../apimethods/api-method';
import { HttpClient } from '@angular/common/http';
import { CC3APIModel } from './cc3-model';
import * as ngswal from "sweetalert";
import { customfunctions, DataParam } from '../common/customfunctions';
import { GlobalConstants } from '../common/global-constants';
declare var $;

@Component({
  selector: 'app-cc3',
  templateUrl: './cc3.component.html',
  styleUrls: ['./cc3.component.css']
})
export class CC3Component implements OnInit {
  modelItem = new CC3APIModel();
  @ViewChild('dataTable', { static: false }) table;
  dataSet: any;
  dataTable: any;

  dataTableSr: any;
  @ViewChild('dataTableSr', { static: false }) tableSr;
  dataSetReport: any;

  file: any;
  fileBase64: any;
  ArticleTypeList: any;
  showCC3ListModal: boolean;
  CC3ModalButton: string = "Submit";
  title: string;
  dataSetSummary: string;
  cc3ALLlist: any;
  cc3WIPlist: any;
  cc3YTSlist: any;
  cc3Copmletedlist: any;
  CurrentStatus: any = null;
  Currentstatus: any = null;
  PublisherList: any;
  journalList: any;
  aArticle: any;
  artcileList: any;
  articleId: number;
  journalListReport: any;
  articleid: number = null;

  static holdType: string;
  showSummaryCalModal: boolean;

  configList: any;

  ngOnInit(): void {
    this.dragAreaClass = "dragarea";

    $('#divConfigDetails').css('height', (GlobalConstants.size.height) - 450);
    $('#divCC3ArticleLog').css('height', (GlobalConstants.size.height) - 380);

    ApiMethod.getBaseUrl();

    setInterval(function () {
      $('#btGetArticleSummaryLog').trigger("click");
    }, 10000);
  }

  constructor(private router: Router) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <CC3APIModel>data["CC3Page"];
        this.CC3ConfigList();
        this.MainGridTable();
        this.GetCC3DashboardCount();
        this.GetArticleTypeList();
        this.GetPublisherList();
        this.GetArticleSummaryLog();
        this.getFilteredReport();

        $("#ddlConfig").select2({
          placeholder: "Select the formula", dropdownParent: "#divContainer"
        });

        $("#ddlJournalList").select2({
          placeholder: "Select Journal", dropdownParent: "#myModalCC3List"
        });
        $("#ddlPublisherReport").select2({
          placeholder: "Select Publisher", dropdownParent: "#CC3tabContent"
        });
        $("#ddlJournalListReport").select2({
          placeholder: "Select Journal", dropdownParent: "#CC3tabContent"
        });
        $("#ddlArticleNo").select2({
          placeholder: "Select Article", allowClear: true, tags: true, dropdownParent: "#myModalCC3List"
        });

        $("#ddlArticleTypeList").select2({
          placeholder: "Select Article Type", allowClear: true, tags: true, dropdownParent: "#myModalCC3List"
        });
        $('#ddlArticleTypeList').val([]).trigger('change');
        customfunctions.SetDateValues("#txtFromDt", "#txtToDt");

        $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
          $($.fn.dataTable.tables(true)).DataTable()
            .columns.adjust();
        });
      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }

  GetArticleTypeList(): void {
    ApiMethod.getMethod(this.modelItem.ArticleTypeListAPI).subscribe(
      result => {
        this.ArticleTypeList = result.aArticleTypeList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  GetArticleList(selectedId = 0): void {
    var jId = $("#ddlJournalList").val();
    ApiMethod.getMethod(this.modelItem.GetArticleDetails + jId).subscribe(
      result => {
        this.artcileList = result.dataItem;
        this.articleId = selectedId;
      }, error => {
        $("#LoadingImage").hide();

      });
  }

  GetPublisherList(): void {
    ApiMethod.getMethod(this.modelItem.PublisherList).subscribe(
      result => {
        this.PublisherList = result.aitemList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  GetJournalsdetails(): void {
    let pubId = $('#ddlPublisher').val();
    ApiMethod.getMethod(this.modelItem.GetJournalsdetails + pubId).subscribe(
      result => {
        this.journalList = result.dataItem;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  GetJournalsdetailsReport(): void {
    let pubId = $('#ddlPublisherReport').val();
    ApiMethod.getMethod(this.modelItem.GetJournalsdetails + pubId).subscribe(
      result => {
        this.journalListReport = result.dataItem;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }


  MainGridTable(CurrentStatus: any | null = null) {

    this.GetCC3DashboardCount();
    //let holdType = $('#ULTabul .nav-link.active')[0].name;

    $("LoadingImage").show();
    this.CurrentStatus = CurrentStatus;
    var dataparam = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      ModuleName: "CC3Module",
      CurrentStatus: this.CurrentStatus

    }
    ApiMethod.postMethod(this.modelItem.CC3ListAPI, dataparam).subscribe(
      Response => {
        let holdType = $('#ULTabul .nav-link.active')[0].name;

        this.dataSet = JSON.stringify(Response.aitemList); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let aColList = Response.acolListL; // grid column data
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 280);
        dataItem.modulename = 'CC3Module';
        dataItem.aNewButtonName = 'btnUploadFile';
        dataItem.isDefault = false;
        dataItem.infoPopupID = "Id";
        dataItem.IdOrder = "desc";
        dataItem.colsetting = false;
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

        $("LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }


  PopupShowCC3List() {
    $('#myModalCC3List').show();
    /* $('#myModalCC3Report').show(); */
  }


  CC3List(): void {
    // Validation
    if ($('#ddlJournalList').val() == '') {
      ngswal("Warning !", "Select Journal!", "warning");
    } else if ($('#ddlArticleNo').val() == '') {
      ngswal("Warning !", "Enter Article No!", "warning");
    }
    else if ($('#ddlArticleTypeList').val() == '') {
      ngswal("Warning !", "Select ArticleType !", "warning");
    }
    else if ($('#doc_uploadfile').val() == "") {
      $('#doc_uploadfile').val("");
      ngswal("Failed !", "Please upload File..!", "warning");
      return;
    }
    else {
      $("#LoadingImagePopup").show();
      let fileName = null; let fileSize = null;
      if (this.file != null) {
        fileName = this.file.name;
        fileSize = this.file.size
      }
      var newData = {

        JournalId: $('#ddlJournalList').val(),
        ArticleNo: $('#ddlArticleNo').val(),
        ArticleTypeId: $('#ddlArticleTypeList').val(),
        fileName: this.file.name,
        fileSize: this.file.size,
        fileAsBase64: this.fileBase64,
        UpdatedBy: localStorage.aLoginID,
        PublisherId: localStorage.aPubID,
        LoginId: localStorage.aLoginID,
      };


      ApiMethod.postMethod(this.modelItem.cc3FileStatusUpdate, newData).subscribe(
        response => {

          if (response.status == 'Success') {
            this.MainGridTable();
            $("#LoadingImagePopup").hide();
            ngswal({
              position: 'top-end',
              type: "success",
              title: "Added !",
              text: response.message,
              showConfirmButton: true,
            });
            this.hideCC3List();

          }
          else {
            ngswal("Failed !", response.message, "warning");
          }
        },
        error => {
          ngswal("Failed !", error.Message, "warning");
          $("#LoadingImagePopup").hide();
        }
      );
    }
  }

  GetDateFormatValue(date) {
    return GlobalConstants.FromateDateWithTime(date);
  }


  getFilteredReport() {
    $("LoadingImage").show();
    var reportData = {
      LoginId: localStorage.aLoginID,
      PublisherId: $("#ddlPublisherReport").val(),
      JournalID: $("#ddlJournalListReport").val(),
      FromDate: $("#txtFromDt").val(),
      ToDate: $("#txtToDt").val(),

    }
    ApiMethod.postMethod(this.modelItem.CC3ReportAPI, reportData).subscribe(
      Response => {
        this.MainGridTable(null);

        this.dataSetReport = JSON.stringify(Response.aitemList); // Data List
        this.dataSetReport = JSON.parse(this.dataSetReport);
        this.dataTableSr = $(this.tableSr.nativeElement);

        //Dynamic datable
        let aColList = Response.acolListL; // grid column data
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.dataTable = this.dataTableSr;
        dataItem.dataset = this.dataSetReport;
        dataItem.dtheight = (GlobalConstants.size.height - 220);
        dataItem.modulename = 'CC3ReportModule';
        /*dataItem.aNewButtonName = 'Btn_AddNew';*/
        dataItem.isDefault = false;
        dataItem.colsetting = false;
        this.dataTableSr = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

        $("LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });

  }


  resetFilter() {
    //$('#btnLoadList').show();
    $("#ddlPublisherReport").val(0).change();
    $("#ddlJournalListReport").val(0).change();
    customfunctions.SetDateValues("#txtFromDt", "#txtToDt");
    this.getFilteredReport();
  }

  UploadFile() {

  }

  ReportView() {

  }

  ClearCC3() {
    $("#ddlJournalList").val(0).change();
    $("#ddlArticleNo").val(0).change();
    $("#ddlArticleTypeList").val(0).change();
    $("#doc_uploadfile").val("");
  }
  hideCC3List() {
    $('#myModalCC3List').hide();

    this.ClearCC3();

  }

  GetCC3DashboardCount() {
    var cc3Data = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID
    };

    ApiMethod.postMethod(this.modelItem.GetCC3DashboardCount, cc3Data).subscribe(
      Response => {
        this.dataSetSummary = JSON.stringify(Response.aCount);
        var aitem = Response.aCount;
        this.cc3ALLlist = (aitem.find(item => item.ID === "ALL") || { Count: 0 }).Count;
        this.cc3YTSlist = (aitem.find(item => item.ID === "YetToStart") || { Count: 0 }).Count;
        this.cc3WIPlist = (aitem.find(item => item.ID === "WIP") || { Count: 0 }).Count;
        this.cc3Copmletedlist = (aitem.find(item => item.ID === "COMPLETED") || { Count: 0 }).Count;


      },
      error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  onuploadSelected(fileInput: any) {
    var ext = $('#doc_uploadfile').val().split('.').pop().toLowerCase();
    if ($.inArray(ext, ['doc', 'docx']) == -1) {
      $('#doc_uploadfile').val("");
      ngswal("Failed !", "Invalid File format", "warning");
      return false;
    } else {
      this.file = fileInput.currentTarget.files[0];
      if (fileInput.currentTarget.files[0]) {
        var fileReader = new FileReader();
        fileReader.onload = (e: any) => {
          this.fileBase64 = null;
          this.fileBase64 = e.currentTarget.result;
          console.log(this.fileBase64);
        }

        fileReader.readAsDataURL(fileInput.currentTarget.files[0]);
      }
    }
  }

  Fileconfirmation() {

    ngswal({
      title: "File Upload",
      text: "Are you sure want to Upload new File?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      closeOnConfirm: true,
      closeOnCancel: true
    },
      function (isConfirm) {

        if (isConfirm) {

          return false;

        } else {
          $("#doc_uploadfile").val("");
          this.fileBase64 = null;
          this.fileName = null;
          this.fileSize = null;
          return false;
        }
      });
  };

  CC3articleSummaryLog: any; CC3articleSummaryLogTrans: any;

  GetArticleSummaryLog() {

    var cc3Data = {
      LoginId: localStorage.aLoginID,
      ArticleId: 0,
      PublisherId: localStorage.aPubID
    };

    ApiMethod.postMethod(this.modelItem.CC3ArticleSummary, cc3Data).subscribe(
      response => {
        let itemList = response.dataItem;
        let ccArtId = 0;
        let uniqueList = GlobalConstants.distinctBy('Id', itemList);

        this.CC3articleSummaryLog = JSON.parse(JSON.stringify(uniqueList));
        this.CC3articleSummaryLogTrans = JSON.parse(JSON.stringify(itemList));

      },
      error => {
        ngswal("Failed !", error.message, "error");
      });


  }

  error: string;
  dragAreaClass: string;

  @HostListener("dragover", ["$event"]) onDragOver(event: any) {
    this.dragAreaClass = "droparea";
    event.preventDefault();
  }
  @HostListener("dragenter", ["$event"]) onDragEnter(event: any) {
    this.dragAreaClass = "droparea";
    event.preventDefault();
  }
  @HostListener("dragend", ["$event"]) onDragEnd(event: any) {
    this.dragAreaClass = "dragarea";
    event.preventDefault();
  }
  @HostListener("dragleave", ["$event"]) onDragLeave(event: any) {
    this.dragAreaClass = "dragarea";
    event.preventDefault();
  }
  @HostListener("drop", ["$event"]) onDrop(event: any) {
    this.dragAreaClass = "dragarea";
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer.files) {
      let files: FileList = event.dataTransfer.files;
      if (files[0]) {
        var fileReader = new FileReader();
        fileReader.onload = (e: any) => {
          this.cc3UploadFileBase64 = e.currentTarget.result;
          this.saveFiles(files);
        }
        fileReader.readAsDataURL(files[0]);
      }
    }
  }

  onFileChange(event: any) {
    let files: FileList = event.target.files;
    var ext = files[0].name.split('.').pop().toLowerCase();
    if ($.inArray(ext, ['doc', 'docx']) == -1) {
      $('#FU_Attchment').val("");
      ngswal("Failed !", "Please Upload document File only !", "warning");
      return false;
    }

    if (files[0]) {
      var fileReader = new FileReader();
      fileReader.onload = (e: any) => {
        this.cc3UploadFileBase64 = e.currentTarget.result;
        this.saveFiles(files);
      }
      fileReader.readAsDataURL(files[0]);
    }

  }


  cc3UploadFile; cc3UploadFileBase64;

  saveFiles(files: FileList) {
    if (files.length > 1) {
      this.error = "Only one file at time allow";
    }
    else if ($('#ddlConfig').val() == 0) {
      ngswal("Failed !", "Select the formula !", "warning");
      $("#file_cc3upload").val("");
      this.cc3UploadFileBase64 = null;
    }
    else {
      this.error = "";
      let _cc3UploadFileBase64 = this.cc3UploadFileBase64;
      ngswal({
        title: "File Upload",
        text: "Are you sure want to Upload '" + files[0].name + "' File?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: '#DD6B55',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        closeOnConfirm: true,
        closeOnCancel: true
      },
        function (isConfirm) {

          if (isConfirm) {
            var newData = {
              CC3ConfigId: $('#ddlConfig').val(),
              fileName: files[0].name,
              fileAsBase64: _cc3UploadFileBase64,
              UpdatedBy: localStorage.aLoginID,
              LoginId: localStorage.aLoginID,
            };
            $("#LoadingImage").show();
            ApiMethod.postMethod('api/CC3FileUpload', newData).subscribe(
              response => {
                $("#LoadingImage").hide();
                if (response.status == 'Success') {
                  $("#LoadingImagePopup").hide();
                  ngswal({
                    position: 'top-end',
                    type: "success",
                    title: "Uploaded !",
                    text: response.message,
                    showConfirmButton: true,
                  });
                  $('#btGetArticleSummaryLog').trigger('click');
                }
                else {
                  ngswal("Failed !", response.message, "warning");
                }
              },
              error => {
                ngswal("Failed !", error.Message, "warning");
                $("#LoadingImage").hide();
              }
            );

          }
          else {
            $("#file_cc3upload").val("");
            this.cc3UploadFileBase64 = null;
            return false;
          }
        });
    }
  }

  HideSummaryCal() {
    this.showSummaryCalModal = false;
  }


  CC3ArticleSummaryLogic() {
    $('#divSummaryLogic').html(''); $('#divSummaryLogicTitle').html('Summary Log ');
    this.showSummaryCalModal = true;
    var data = {
      LoginId: localStorage.aLoginID,
      CC3ArticleId: localStorage.aEID
    };
    $("#LoadingImagePopup").show();
    ApiMethod.postMethod(this.modelItem.cc3SummaryLogic, data).subscribe(
      response => {
        let datavalue = response.dataItem;
        let scoreVal = 0;
        $('#divSummaryLogicTitle').html(datavalue[0].ArticleNo);
        let htmlData = '';
        //htmlData += '<div><strong>WordsDivision : ' + datavalue[0].WordsDivision + '</strong></div><hr/>';
        htmlData += '<table width="100%"><thead>';
        htmlData += '<th>Category</th><th>Values</th><th>Applicable Category</th><th>Weightage</th></thead><hr/>';
        $.each(datavalue, function (e, val) {
          htmlData += '<tr>';
          htmlData += '<td>' + val.Category + '</td>';
          htmlData += '<td>' + val.CategoryValue + '</td>';
          htmlData += '<td>' + val.ApplicableSummary + '</td>';
          htmlData += '<td>' + 100 / val.Division + '%</td>';
          htmlData += '<tr>';
          htmlData += '</tr>';
          if (val.ApplicableSummary) {
            scoreVal += (val.CategoryValue / val.Division);
          }
        });
        htmlData += '</tr></table>';
        htmlData += '<hr/>';
        htmlData += '<div class=row>';

        htmlData += '<div class="col-sm-4"><strong>Sum of Values : ' + scoreVal + '</strong></div>';
        htmlData += '<div class="col-sm-4"><strong>No of Pages : ' + datavalue[0].NoOfPages + '</strong></div>';
        htmlData += '<div class="col-sm-4"><strong>' + scoreVal + '/' + datavalue[0].NoOfPages + ' = '
          + scoreVal / datavalue[0].NoOfPages + '</strong></div>';
        htmlData += '</div>';
        $('#divSummaryLogic').html(htmlData);
      },
      error => {
        console.log(error.Message);
        $("#LoadingImagePopup").hide();
      }
    );
  }


  CC3ConfigList(): void {
    ApiMethod.getMethod(this.modelItem.CC3ConfigList + '/' + localStorage.aLoginID).subscribe(
      result => {
        this.configList = result.dataItem;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  CC3ConfigCategoryList(): void {
    $('#divConfigDetails').html('<br/>');
    var id = $("#ddlConfig").val();

    if ($("#ddlConfig").val() != 0) {
      $("#LoadingImage").show();
      ApiMethod.getMethod(this.modelItem.CC3ConfigCategoryList + id).subscribe(
        result => {
          let datavalue = result.dataItem;

          let htmlData = '<div>';
          htmlData += '<div>';
          htmlData += '<div><strong>Formula : ' + datavalue[0].FormulaName + '</strong></div>';
          //htmlData += '<div class="col-6"><strong>Words Division : ' + datavalue[0].WordsDivision + ' </strong></div>';
          htmlData += '</div>';
          htmlData += '<table width="100%"><thead>';
          htmlData += '<th>Category</th><th><center>Applicable Category</center></th><th><center>Weightage</center></th></thead><hr/>';
          $.each(datavalue, function (e, val) {
            htmlData += '<tr>';
            htmlData += '<td>' + val.Category + '</td>';
            htmlData += '<td><center>' + (val.ApplicableSummary ? 'Yes' : 'No') + '</center></td>';
            htmlData += '<td><center>' + (100 / val.Division) + '% </center></td>';
            htmlData += '<tr>';
            htmlData += '</tr>';
          });
          htmlData += '</tr></table>';
          htmlData += '</div><br/>';

          $('#divConfigDetails').html(htmlData);
          $("#LoadingImage").hide();
        }, error => {
          $("#LoadingImage").hide();
          ngswal("Warning !", error, "warning");
        });
    }

  }

  RemoveEntery(id: string) {
    let apiurl = this.modelItem.DeleteCC3Article + id;
    ngswal({
      title: "Confirmation",
      text: "Are you sure want to delete?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      closeOnConfirm: true,
      closeOnCancel: true
    },
      function (isConfirm) {
        if (isConfirm) {
          $("#LoadingImage").show();
          ApiMethod.getMethod(apiurl).subscribe(
            result => {
              let datavalue = result;

              if (datavalue.status) {
                ngswal("Deleted !", datavalue.message, "info");
              }
              else {
                ngswal("Warning !", datavalue.message, "warning");
              }
              $("#LoadingImage").hide();
            }, error => {
              $("#LoadingImage").hide();
              ngswal("Warning !", error, "warning");
            });

          return false;
        }
        else {
          return false;
        }
      });
  }
}
